<!-- eslint-disable vue/multi-word-component-names -->
<!-- Markup generated verbatim from the-dream-international.html (page "faq"). -->
<template>
<div class="page" data-page="faq">
  <section class="phero">
    <div class="corner" aria-hidden="true"><svg viewBox="96 123 492 460" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="The Dream International"><path class="lg-gold" d="M 107.8 282.2 L 103.7 356.6 L 251.6 354 L 126.9 467.6 L 183.5 521.5 L 346.2 362.6 L 410.2 360.6 L 412.2 291.1 Z M 107.8 282.2"/><path class="lg-navy" d="M 412.9 272.6 L 428.1 130.1 L 428.2 129.4 L 353 129 L 345.9 270 Z M 412.9 272.6"/><path class="lg-navy" d="M 325.5 269.5 L 228.9 149.2 L 175.3 198.7 L 247 267.5 Z M 325.5 269.5"/><path class="lg-navy" d="M 432.9 275.7 L 431.2 352.6 L 550.9 265.7 L 505.5 210.1 Z M 432.9 275.7"/><path class="lg-gold" d="M 573.9 355.5 L 269.3 365.1 L 276 574.5 L 348.3 567.5 L 337.3 456.6 L 457.2 552.2 L 501.5 504 L 398.1 422.9 L 580.2 425.9 Z M 573.9 355.5"/></svg></div>
    <div class="wrap">
      <span class="eyebrow"><span class="dot"></span>FAQ</span>
      <h1>Questions, answered.</h1>
      <p class="lede">Still need help? Write to admin@thedreaminc.org. Our team answers every day.</p>
    </div>
  </section>
  <section class="block">
    <div class="wrap">
      <div class="faq-group">
        <h2>For students</h2>
        <div>
          <details><summary>How much does it cost?<span class="pm" aria-hidden="true"></span></summary><div class="ans">Costs vary by country and program. Your referral partner or our program team can tell you what applies where you live.</div></details>
          <details><summary>How do I sign up?<span class="pm" aria-hidden="true"></span></summary><div class="ans">You need a referral code. Ask one of our referral partners or contact our program team, then use the code to finish signing up.</div></details>
          <details><summary>How am I matched with a teacher?<span class="pm" aria-hidden="true"></span></summary><div class="ans">On the Find a Student page you browse programs and teacher profiles, then choose the teacher and time that suit your goals and schedule.</div></details>
          <details><summary>Can I choose my schedule?<span class="pm" aria-hidden="true"></span></summary><div class="ans">Yes. Matches are arranged around your availability, so you and your teacher agree on a schedule that works for both of you.</div></details>
          <details><summary>How long is a course?<span class="pm" aria-hidden="true"></span></summary><div class="ans">Most courses run about 10 weeks. The exact length depends on the program and its content.</div></details>
          <details><summary>Is it for beginners?<span class="pm" aria-hidden="true"></span></summary><div class="ans">It is for every level. Teachers adjust the content and pace to meet each student where they are.</div></details>
          <details><summary>Do I need special software?<span class="pm" aria-hidden="true"></span></summary><div class="ans">Usually not. If a course needs particular software or equipment, your teacher will tell you well in advance.</div></details>
          <details><summary>How do I talk with my teacher?<span class="pm" aria-hidden="true"></span></summary><div class="ans">Once you are matched, the email address of your teacher appears on MyPage. Live chat is on our roadmap.</div></details>
          <details><summary>Will I get a certificate?<span class="pm" aria-hidden="true"></span></summary><div class="ans">Not yet. Certificates are under consideration as we continue to improve our programs.</div></details>
        </div>
      </div>
      <div class="faq-group">
        <h2>For teachers</h2>
        <div>
          <details><summary>What can I teach?<span class="pm" aria-hidden="true"></span></summary><div class="ans">English through SBS, computer literacy through LBL (from Microsoft 365 to coding and cybersecurity), or Korean language and culture through Hanbud.</div></details>
          <details><summary>Will I be trained?<span class="pm" aria-hidden="true"></span></summary><div class="ans">Yes. We hold training before each season and support teachers while the season runs.</div></details>
        </div>
      </div>
      <div class="faq-group">
        <h2>For donors</h2>
        <div>
          <details><summary>Is my donation tax-deductible?<span class="pm" aria-hidden="true"></span></summary><div class="ans">The Dream Inc. is a 501(c)(3) public charity (EIN 30-1295205). Contributions are tax-deductible to the extent allowed by law, and no goods or services are provided in exchange.</div></details>
          <details><summary>How can I give?<span class="pm" aria-hidden="true"></span></summary><div class="ans">By Zelle to finance@thedreaminc.org, or through PayPal. See Get involved for details.</div></details>
        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import { SITE } from '@/data/site';
import { openLogin } from '@/composables/useLogin';
import { copyText } from '@/composables/useToast';

export default {
  name: 'FAQ',
  methods: {
    openLogin,
    openPaypal() {
      window.open(SITE.paypalDonateUrl, '_blank', 'noopener');
    },
    copy(key) {
      copyText(SITE.copyValues[key], this.$el.querySelector('#' + key));
    },
  },
};
</script>
